import { useEffect, useState } from 'react';
import { brandsAPI, uploadsAPI } from './api';

const STORAGE_KEY = 'brandLogos';
const EVENT = 'brand-logos-changed';
let cache = null;
let pending = null;

const readCache = () => {
  if (cache) return cache;
  try { cache = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch { cache = {}; }
  return cache;
};

export const loadBrandLogos = async (force = false) => {
  if (!force && pending) return pending;
  pending = brandsAPI.getAll().then(list => {
    cache = Object.fromEntries(list.filter(b => b.logo).map(b => [b.name, b.logo]));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
    window.dispatchEvent(new Event(EVENT));
    return cache;
  }).catch(() => readCache());
  return pending;
};

export const brandPath = (brand) => `/marque/${encodeURIComponent((typeof brand === 'string' ? brand : brand.slug || brand.name) || '')}`;

export const useBrandLogos = () => {
  const [logos, setLogos] = useState(readCache);
  useEffect(() => {
    const sync = () => setLogos({ ...readCache() });
    window.addEventListener(EVENT, sync);
    loadBrandLogos();
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return logos;
};

export const useBrandLogo = (brand) => {
  const logos = useBrandLogos();
  const url = logos[(brand || '').trim().toUpperCase()];
  return url ? uploadsAPI.resolveUrl(url) : null;
};
